import { registerEventHandlers } from "/events";

import "/modules/base";
import "/modules/legacy";
import "/modules/leaving-popup";

import { setWdyhauTrafficCookie } from "/modules/wdyhau-survey";
import { eventHandlers as abTestEventHandlers } from "/modules/abtest-toggle";

import "/features/smartbanner/init";
import "/features/trial-duration-explanation/init";
import { eventHandlers as categoryExplorerEventHandlers } from "/features/category-explorer/init";

import "/styles/partner-page";

import "/wds/sprites/category";

registerEventHandlers([
  categoryExplorerEventHandlers,
  abTestEventHandlers
]);

setWdyhauTrafficCookie();
